'use client';

import Image from 'next/image';
import Link from 'next/link';
import { Product, formatPrice, getVariantPrice } from '@/lib/products';
import { useTranslation } from '@/context/LanguageContext';
import styles from './ProductCard.module.scss';

interface ProductCardProps {
  product: Product;
}

export default function ProductCard({ product }: ProductCardProps) {
  const { t, currency } = useTranslation();
  const lowestPrice = Math.min(...product.variants.map((v) => getVariantPrice(v, currency)));
  const cardLabel = product.cardLabel?.trim();
  const baseImageSrc = product.image?.trim() || '';
  const cardImageSrc = product.cardImage?.trim() || '';
  const mainImageSrc = cardImageSrc || baseImageSrc;
  const hoverImageSrc = cardImageSrc && baseImageSrc ? baseImageSrc : '';

  return (
    <Link href={`/shop/${product.slug}`} className={styles.card}>
      <div className={styles.imageWrap}>
        {mainImageSrc && (
          <Image
            src={mainImageSrc}
            alt={product.name}
            width={400}
            height={400}
            className={styles.mainImage}
            style={{ objectFit: 'cover', width: '100%', height: '100%' }}
          />
        )}
        {hoverImageSrc && (
          <Image
            src={hoverImageSrc}
            alt={product.name}
            width={400}
            height={400}
            className={styles.hoverImage}
            style={{ objectFit: 'cover', width: '100%', height: '100%' }}
          />
        )}
      </div>
      <div className={styles.info}>
        <h3 className={styles.name}>{product.name}</h3>
        <p className={styles.flavor}>{product.flavor}</p>
        <div className={styles.meta}>
          {cardLabel && <span className={styles.roast}>{cardLabel}</span>}
          <span className={styles.price}>{t.productCard.pricePrefix} {formatPrice(lowestPrice, t)}</span>
        </div>
      </div>
    </Link>
  );
}
